module.exports = {"TXTACL_Close":{"id":"TXTACL_Close","defaultMessage":"Close","flags":["TRACK"],"track":"Close"}}